export const TYPES = {
  TABLE: "decision-table",
  FIRST_ROW: "first-row",
  ROW: "table-row",
  LAST_ROW: "last-row",
  ALT_CONCLUSION: "OPM-Alternativeconclusion",
  HEADER: "header",
};
